import { Vue } from 'ui.vue';
import { bonus } from 'germes.bonus';
Vue.component('vue-contragent-bonus-icon', {
    data() {
        return {
            REAL_PRODUCT_PRICE: null
        };
    },
    computed: {
        localize() {
            return Vue.getFilteredPhrases("");
        },
        isAnalog(state) {
            return state.$props.productAnalog == 'Y';
        },
        basketProduct(state) {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/findItem'](state.$props.productId) : null;
        },
        basketStatus(state) {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/basketStatus'] : null;
        },
        catalogProduct(state) {
            return state.$store.hasModule("catalog") ? state.$store.getters['catalog/findItem'](state.$props.productId) : null;
        },
        catalogProductCanBuyForBonuses(state) {
            return (
                state.basketProduct?.QUANTITY > 0 &&
                this.checkByProductByBonus() &&
                // state.catalogProduct?.DISPLAY_PROPERTIES?.BONUS_EXCHANGE?.VALUE == 'Y' &&
                state.$store.getters['basket/getContragent']?.BONUS_SUMM > 0 &&
                true
            );
        },
        catalogProductBuyForBonuses(state) {
            return state.basketProduct?.PROPS?.BONUS_EXCHANGE?.VALUE == 'Y';
        },
    },
    methods: {
        toggleProductProps: function () {
            if (typeof this.basketProduct?.PROPS == 'undefined') this.basketProduct.PROPS = {};
            if (!this.catalogProductBuyForBonuses) {
                let product = this.basketProduct;
                BX.onCustomEvent("OnBeforeProductBonusBuyOn", product);
                this.$store.commit('basket/setProductProperty', {
                    ID: product.ID, PROPS: {
                        BONUS_EXCHANGE: {
                            CODE: 'BONUS_EXCHANGE',
                            NAME: 'BONUS_EXCHANGE',
                            VALUE: 'Y'
                        }
                    }
                });
                BX.onCustomEvent("OnAfterProductBonusBuyOn", product);
            } else {
                BX.onCustomEvent("OnBeforeProductBonusBuyOff", product);
                this.$store.commit('basket/setProductProperty', {
                    ID: this.basketProduct.ID, PROPS: {
                        BONUS_EXCHANGE: false
                    }
                });
                BX.onCustomEvent("OnAfterProductBonusBuyOff", product);
            }
        },
        toggleProductSale: function () {
            if (this.REAL_PRODUCT_PRICE == null && this.catalogProduct.PRICE) this.REAL_PRODUCT_PRICE = this.catalogProduct.PRICE;
            if (!this.catalogProductBuyForBonuses && this.catalogProduct.PRICE > 0) {
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: 0,
                    DISCOUNT_PRICE: this.catalogProduct.PRICE,
                });
            } else if (this.REAL_PRODUCT_PRICE > 0) {
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: this.REAL_PRODUCT_PRICE,
                    DISCOUNT_PRICE: 0,
                });
            }
        },
        toggleByProductByBonus: function (event) {
            this.toggleProductProps();
        },
        checkByProductByBonus: function () {
            if (this.catalogProductBuyForBonuses && this.catalogProduct.PRICE > 0 && this.REAL_PRODUCT_PRICE == null) {
                this.REAL_PRODUCT_PRICE = this.catalogProduct.PRICE;
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: 0,
                    DISCOUNT_PRICE: this.catalogProduct.PRICE,
                });
            }
            if (!this.catalogProductBuyForBonuses && this.catalogProduct.PRICE == 0 && this.REAL_PRODUCT_PRICE > 0) {
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: this.REAL_PRODUCT_PRICE,
                    DISCOUNT_PRICE: 0,
                });
                this.REAL_PRODUCT_PRICE = null;
            }
            return true
        }
    },
    mounted() { },
    props: {
        'productId': Number,
        'productAnalog': String
    },
    template: `
        <div
            v-if="catalogProductCanBuyForBonuses"
            :id="'BONUS_'+productId"
            :title="localize?.USE_BONUS"
            @click.stop="toggleByProductByBonus"
            data-toggle="tooltip"
            data-placement="bottom"
            class="text-info pointer"
            >
            <i :class="['fas fa-coins', {'text-dark': !catalogProductBuyForBonuses},{'text-success': catalogProductBuyForBonuses}]"></i>
        </div>`
});
// userStore.commit("/addProductSettingsModule", { name: 'vue-product-buy-bonus-toggle-button', sort: 1000 });
